<h1 mat-dialog-title translate>ecommerceDialogTPV.title</h1>
<mat-dialog-content>
  <mat-grid-list cols="18" rowHeight="60px">
    <mat-grid-tile colspan="6" rowspan="1">
      <div>
        <mat-label translate>ecommerceDialogTPV.guid</mat-label>
        <mat-label>{{ ecommerceReportDetailDTO.id }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="6" rowspan="1">
      <div>
        <mat-label translate>ecommerceDialogTPV.reference</mat-label>
        <mat-label>{{ ecommerceReportDetailDTO.orderCode }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="6" rowspan="1">
      <div>
        <mat-label translate>ecommerceDialogTPV.fuc</mat-label>
        <mat-label>{{ ecommerceReportDetailDTO.fuc }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="9" rowspan="1">
      <div>
        <mat-label translate>ecommerceDialogTPV.name</mat-label>
        <mat-label>{{ ecommerceReportDetailDTO.business }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="9" rowspan="1">
      <div>
        <mat-label translate>ecommerceDialogTPV.codeAuthorization</mat-label>
        <mat-label>{{ ecommerceReportDetailDTO.codeAuthorization }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="9" rowspan="1">
      <div>
        <mat-label translate>ecommerceDialogTPV.description</mat-label>
        <mat-label>{{ ecommerceReportDetailDTO.productDescription }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="9" rowspan="1">
      <div>
        <mat-label translate>ecommerceDialogTPV.type</mat-label>
        <mat-label>{{ ecommerceReportDetailDTO.transactionType }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="9" rowspan="1">
      <div>
        <mat-label translate>ecommerceDialogTPV.holder</mat-label>
        <mat-label>{{ ecommerceReportDetailDTO.holder }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="9" rowspan="1">
      <div>
        <mat-label translate>ecommerceDialogTPV.price</mat-label>
        <mat-label>{{ ecommerceReportDetailDTO.amount }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="9" rowspan="1">
      <div>
        <mat-label translate>ecommerceDialogTPV.dateAuthorization</mat-label>
        <mat-label>{{
          ecommerceReportDetailDTO.transactionDate + ' ' + ecommerceReportDetailDTO.transactionHour
        }}</mat-label>
      </div>
    </mat-grid-tile>
    <mat-grid-tile colspan="9" rowspan="1">
      <div>
        <mat-label translate>ecommerceDialogTPV.codeResponse</mat-label>
        <mat-label>{{ ecommerceReportDetailDTO.responseCode }}</mat-label>
      </div>
    </mat-grid-tile>
  </mat-grid-list>
</mat-dialog-content>
